package tables.category

import emotion.react.css
import kotlinx.browser.window
import models.CategoryModel
import org.w3c.fetch.RequestInit
import react.FC
import react.Props
import react.dom.html.ReactHTML.button
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.input
import react.dom.html.ReactHTML.table
import react.dom.html.ReactHTML.tbody
import react.dom.html.ReactHTML.td
import react.dom.html.ReactHTML.th
import react.dom.html.ReactHTML.thead
import react.dom.html.ReactHTML.tr
import react.useEffect
import react.useState
import token
import urlAddress
import web.cssom.BorderCollapse
import web.cssom.Color
import web.cssom.TextAlign
import web.cssom.px
import web.html.InputType

external interface CategoryProps : Props

val CategoryTable = FC<CategoryProps> {

    val (categories, setCategories) = useState(emptyList<CategoryModel>())
    var categoryName by useState("")
    var isModalOpen: CategoryModel? by useState(null)
    var isModalOpenCreate by useState(false)

    fun loadCategories() {
        window.fetch(urlAddress + "api/category", RequestInit(
            method = "GET",
            headers = web.http.Headers().apply {
                append("Authorization", "Bearer $token")
            }
        ))
            .then { response -> response.json() }
            .then { data ->
                val newResultList = (data as? Array<dynamic> ?: emptyArray()).mapNotNull {
                    CategoryModel(
                        it.id as? Int ?: 0,
                        it.name as? String ?: "",
                        it.parent as? String ?: "",
                        it.iscategory as? Boolean ?: true,
                        it.isactive as? Boolean ?: true,

                    )
                }
                setCategories(newResultList)
            }
    }

    useEffect(categories.isEmpty()) {
        loadCategories()
    }

    UpdateCategoryModal {
        categoryModel = isModalOpen
        listCategoryModel = categories
        onClose = {
            isModalOpen = null
        }
        onUpdate = {
            loadCategories()
        }

    }

    CreateCategoryModal {
        isOpen = isModalOpenCreate
        listCategoryModel = categories
        onClose = {
            isModalOpenCreate = false
        }
        onUpdate = {
            loadCategories()
        }
    }

    div {
        div {
            +"Введите наименование Категории:"
            input {
                css {
                    fontSize = 14.px
                }
                value = categoryName
                type = InputType.text
                onChange = { event ->
                    categoryName = event.target.value
                }
            }
            button {
                +"Добавить"
                onClick = {
                    isModalOpenCreate = true
                }
            }
        }

        table {
            border = 1
            css {
                borderColor = Color("#000")
                borderCollapse = BorderCollapse.collapse
                textAlign = TextAlign.center
            }
            thead {
                tr {
                    th { +"Наименование" }
                    th { +"Категория" }
                    th { +"Является категорией" }
                    th { +"Активная" }
                    th { +"Действие" }
                }
            }
            tbody {
                categories.filter { it.name.lowercase().contains(categoryName.lowercase()) }.forEach { item ->
                    tr {
                        td { +item.name }
                        td { +item.parent }
                        td { +"${item.iscategory}" }
                        td { +"${item.isactive}" }
                        td {
                            button {
                                css {
                                    margin = 5.px
                                    marginBottom = 5.px
                                    fontSize = 14.px
                                }
                                +"✏️"
                                onClick = {
                                    isModalOpen = item
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

